export const HORIZONTAL = 'horizontal';
export const VERTICAL = 'vertical';

export const orientationValues = [
    { value: HORIZONTAL, label: HORIZONTAL },
    { value: VERTICAL, label: VERTICAL },
];
